import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Add.svg",
  "use": "Add.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Add.svg\"><path d=\"M50.01,34.0209h-16v16a2,2,0,1,1-4,0v-16h-16a2,2,0,0,1,0-4h16v-16a2,2,0,1,1,4,0v16h16a2,2,0,0,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol